/* tslint:disable */
/* eslint-disable */
/**
 * Procon BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonFeedbackDataDto
 */
export interface JsonFeedbackDataDto {
    /**
     * 
     * @type {string}
     * @memberof JsonFeedbackDataDto
     */
    deviceId: string;
    /**
     * 
     * @type {string}
     * @memberof JsonFeedbackDataDto
     */
    hwid: string;
    /**
     * 
     * @type {string}
     * @memberof JsonFeedbackDataDto
     */
    devPubKey: string;
    /**
     * 
     * @type {string}
     * @memberof JsonFeedbackDataDto
     */
    lhSerial: string;
    /**
     * 
     * @type {string}
     * @memberof JsonFeedbackDataDto
     */
    softwareVersion: string;
}

/**
 * Check if a given object implements the JsonFeedbackDataDto interface.
 */
export function instanceOfJsonFeedbackDataDto(value: object): value is JsonFeedbackDataDto {
    if (!('deviceId' in value) || value['deviceId'] === undefined) return false;
    if (!('hwid' in value) || value['hwid'] === undefined) return false;
    if (!('devPubKey' in value) || value['devPubKey'] === undefined) return false;
    if (!('lhSerial' in value) || value['lhSerial'] === undefined) return false;
    if (!('softwareVersion' in value) || value['softwareVersion'] === undefined) return false;
    return true;
}

export function JsonFeedbackDataDtoFromJSON(json: any): JsonFeedbackDataDto {
    return JsonFeedbackDataDtoFromJSONTyped(json, false);
}

export function JsonFeedbackDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonFeedbackDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'deviceId': json['deviceId'],
        'hwid': json['hwid'],
        'devPubKey': json['devPubKey'],
        'lhSerial': json['lhSerial'],
        'softwareVersion': json['softwareVersion'],
    };
}

export function JsonFeedbackDataDtoToJSON(json: any): JsonFeedbackDataDto {
    return JsonFeedbackDataDtoToJSONTyped(json, false);
}

export function JsonFeedbackDataDtoToJSONTyped(value?: JsonFeedbackDataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deviceId': value['deviceId'],
        'hwid': value['hwid'],
        'devPubKey': value['devPubKey'],
        'lhSerial': value['lhSerial'],
        'softwareVersion': value['softwareVersion'],
    };
}

